import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { GetInvoiceParams } from '../../../../../services/invoice/InvoiceService';

import ApiContext from '../../contexts/ApiContext';
import { Invoice } from '../../../../../types/invoices/Invoices';

/**
 *  Hook for fetching invoices
 */
const useInvoices = (params: GetInvoiceParams, enabled: boolean = true) => {
  const { invoiceApi } = useContext(ApiContext);

  if (!invoiceApi) {
    return {
      invoices: [],
      error: 'InvoiceApi is not defined',
      status: 'error',
    };
  }

  const { data: invoices, status, isRefetching } = useQuery({
    queryKey: ['invoices', JSON.stringify(params)],
    queryFn: () => invoiceApi.getInvoices<Invoice[]>(params),
    enabled,
  });

  return {
    invoices,
    status,
    isRefetching,
  };
};

export default useInvoices;
